module.exports = __webpack_public_path__ + "img/port.e8e5dc46.png";